import { Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, Spinner, InputGroup, Input, Item, View, Tab, Tabs } from 'native-base';
import { Animated, Easing, Platform } from 'react-native';
import PopupMenu from './popupMenu';
import * as React from 'react';

//https://medium.com/react-native-motion/toolbar-animation-in-react-native-2-2-f04ac45c7c11

export default class AnimatedSearchBar extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			leftElement: props.showHamburger && 'menu',
			spinValue: new Animated.Value(0)
		};
	}
	componentWillReceiveProps(nextProps) {
		// goes to search state
		if (nextProps.isSearchActive && !this.props.isSearchActive) {
			this.animate({ toValue: 1, leftElement: 'arrow-forward' });
		}
		// goes to default look
		if (!nextProps.isSearchActive && this.props.isSearchActive) {
			this.animate({ toValue: 0, leftElement: this.props.showHamburger && 'menu' });
		}
	}
	animate = ({ toValue, leftElement }) => {
		Animated.timing(this.state.spinValue, {
			toValue: 0.5,
			duration: 112,
			easing: Easing.linear,
			useNativeDriver: Platform.OS === 'android'
		}).start(() => {
			this.setState({ leftElement });

			Animated.timing(this.state.spinValue, {
				toValue,
				duration: 112,
				easing: Easing.linear,
				useNativeDriver: Platform.OS === 'android'
			}).start();
		});
	};
	render() {
		const { leftElement, spinValue } = this.state;
		const { isSearchActive, onSearchClose, onSearchOpen, onUserAdd, title = 'People', popupMenu = true, extraButton, emptyText = 'Search' } = this.props;

		const spin = this.state.spinValue.interpolate({
			inputRange: [0, 1],
			outputRange: ['0deg', '180deg']
		});

		return (
			<Header hasTabs searchBar rounded>
				<Left>
					<Animated.View style={[{ transform: [{ rotate: spin }] }]}>
						<Icon name={leftElement} style={{ color: 'white' }} onPress={() => onSearchClose()} />
					</Animated.View>
				</Left>
				{isSearchActive ? (
					<Item visible>
						<Icon active name="search" />
						<Input autoFocus placeholder={emptyText} onChangeText={searchString => this.props.onChangeText(searchString)} style={{ overflow: 'hidden' }} />
						<Icon active name="people" />
					</Item>
				) : (
					<Body>
						<Title>{title}</Title>
					</Body>
				)}
				{!isSearchActive && (
					<Right style={{ alignItems: 'center' }}>
						<Button transparent onPress={() => onSearchOpen()}>
							<Icon name="search" />
						</Button>

						{popupMenu && <PopupMenu icon={'person-add'} actions={['New', 'From phone book']} onPress={onUserAdd} style={{}} />}
						{extraButton}
					</Right>
				)}
			</Header>
		);
	}
}
